var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0052CC",
    stroke: "#0052CC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71929 11.3053C9.62704 11.2098 9.5167 11.1336 9.39469 11.0812C9.27269 11.0288 9.14147 11.0012 9.00869 11C8.87591 10.9989 8.74423 11.0242 8.62133 11.0745C8.49844 11.1247 8.38679 11.199 8.29289 11.2929C8.199 11.3868 8.12475 11.4984 8.07447 11.6213C8.02419 11.7442 7.99888 11.8759 8.00004 12.0087C8.00119 12.1415 8.02878 12.2727 8.08119 12.3947C8.1336 12.5167 8.20978 12.627 8.30529 12.7193L10.3053 14.7193C10.4928 14.9068 10.7471 15.0121 11.0123 15.0121C11.2775 15.0121 11.5318 14.9068 11.7193 14.7193L15.7193 10.7193C15.8148 10.627 15.891 10.5167 15.9434 10.3947C15.9958 10.2727 16.0234 10.1415 16.0245 10.0087C16.0257 9.87591 16.0004 9.74423 15.9501 9.62133C15.8998 9.49844 15.8256 9.38679 15.7317 9.29289C15.6378 9.199 15.5261 9.12475 15.4032 9.07447C15.2803 9.02419 15.1487 8.99888 15.0159 9.00004C14.8831 9.00119 14.7519 9.02878 14.6299 9.08119C14.5079 9.1336 14.3975 9.20978 14.3053 9.30529L11.0123 12.5983L9.71929 11.3053Z",
    fill: "#FAFBFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.5ca5e2617d708ce7b56cb8600f9d02ca.svg";
export { ForwardRef as ReactComponent };